<template>
    <div class="ckeditor">
        <textarea :name="name" :id="id" :value="html"></textarea>
    </div>
</template>

<script>
    let inc = 0;

    export default {
        props: {
            preventLeave: {
                type: Boolean,
                default: false
            },
            value: {
                type: String
            },
            id: {
                type: String,
                default: () => `editor-${++inc}`
            },
            height: {
                type: String,
                default: '200px'
            },
            toolbar: {
                type: [String, Array],
                default: null
            },
            language: {
                type: String,
                default: 'en'
            },
            extraplugins: {
                type: String,
                default: 'font'
            },
            name: {
                type: String,
                default: ''
            },
            basehtml: {
                type: String,
                default: ''
            },
            extradata: {
                type: Object,
                default: null
            }
        },
        data() {
            return {
                emit: false,
                html: this.basehtml,
                timeout: false,
                editorConfig: {
                    extraPlugins: 'font',
                    toolbar: [ [['Source', 'Format'], ['Font','FontSize'],['Bold', 'Italic', 'SpecialChar', 'Scayt'], ['Undo', 'Redo'], ['NumberedList','BulletedList'], ['Link','Unlink'], ['Maximize'], ['Image'], ['Outdent', 'Indent', 'Styles'] ] ]
                }
            }
        },
        computed: {
            instance() {
                return CKEDITOR.instances[this.id];
            }
        },
        created() {
            if (this.basehtml !== '') {
                // this.instance.setData(this.basehtml);
            }
            this.$eventHub.$on('updateCkeditor', this.updateCkeditor)
        },
        methods: {
            updateCkeditor (html) {
                if (html !== this.instance.getData()) {
                    this.instance.setData(html)
                }
            },
        },
        mounted () {
            let config = {
                toolbar: this.toolbar,
                language: this.language,
                height: this.height,
                extraPlugins: this.extraplugins
            };

            if (this.extradata && typeof this.extradata === 'object' && typeof this.extradata['' !== 'undefined']) {
                config = Object.assign(this.extradata, config)
            }
            
            CKEDITOR.replace(this.id, config);

            this.instance.on('change', () => {
                clearTimeout(this.timeout);
                this.html = this.instance.getData();
                this.timeout = setTimeout(function () {
                    this.$emit('input', this.html);
                    this.$eventHub.$emit('updateCkeditorHtml', this.html);
                }.bind(this), 100);
            });

            this.instance.on('key', (e) => {
                if (this.preventLeave) {
                    window.BOLD.ajaxFormIsChanged = true;
                }
            });
        },
        beforeDestroy () {
            if (this.instance) {
                this.instance.focusManager.blur(true);
                this.instance.destroy();
            }
        }
    }
</script>
<style>
    .ckeditor::after {
        content: "";
        display: table;
        clear: both;
    }
</style>